import { Component, OnInit ,Input, Output, EventEmitter} from '@angular/core';
import {  Router } from '@angular/router';
import { UserapiService } from 'src/app/common/userapi.service';

@Component({
  selector: 'app-website-footer',
  templateUrl: './website-footer.component.html',
  styleUrls: ['./website-footer.component.css']
})
export class WebsiteFooterComponent implements OnInit {

  arr_onlineservices=[];
  arr_currentupdates=[];
 

  CurrentYear: number;
  constructor(private user:UserapiService,private route: Router,) { this.CurrentYear = new Date().getFullYear(); }
  ScrollTop() {
    const element = document.querySelector('.sigma_header-top'); // Replace '.banner-wrap' with the appropriate CSS selector of the element you want to scroll to
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  }

  ngOnInit() {
    this.onlineservicesnotification()
    this.currentupdatesnotification();
  }

  onlineservicesnotification(){

    const ShowOnOnlineServices=1;
    this.arr_onlineservices = [];
      this.user.GET("notification_get_onlineservices?ShowOnOnlineServices=" + ShowOnOnlineServices).then(data => {
    
        this.arr_onlineservices=data
        //console.log(this.arr_onlineservices)
        
      })
  }

  currentupdatesnotification(){

    const ShowOnCurrentUpdates=1;
    this.arr_onlineservices = [];
      this.user.GET("notification_get_currentupdates?ShowOnCurrentUpdates=" + ShowOnCurrentUpdates).then(data => {
     
        this.arr_currentupdates=data
        //console.log(this.arr_currentupdates)
        
      })
  }

    bindnotificationdetail(item){
      this.route.navigate(['/home-page/notificationdetail', item.NotificationID]);
    }

}
